import script from "./BaziPredictionResult.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaziPredictionResult.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__